import React from "react";
import "./specializeBilling.scss";
import about from "../../../assets/UMSImage/About_Main.png";
import Button from "../../Common/Button/Button";
import { Specializes } from "../../../constants/Home";

const SpecializeBilling = () => {
  return (
    <section id="specialize-billing-wrapper">
      <div className="row">
        <div className="col-md-6 bg-image">
          <img src={about} alt="" />
        </div>
        <div className="col-md-6 specialize">
          <h2 className="heading">
            We Specialize in <span>Medical Billing</span>
          </h2>
          <p>
            Our team specializes in medical billing, ensuring that healthcare
            providers receive timely and accurate reimbursement for their
            services. With years of experience in the field, we are well-versed
            in the complex world of medical coding and billing regulations. Our
            services include claim submission, follow-up, and appeals to
            maximize revenue and minimize the risk of denied claims. Let us
            handle the administrative burden of medical billing so that
            healthcare providers can focus on what they do best – providing
            high-quality care to their patients.
          </p>
          {Specializes?.map((item) => {
            return (
              <>
                <div className="options">
                  <img src={item?.image} alt="" />
                  <span>{item?.title}</span>
                </div>
              </>
            );
          })}
          <div className="mb-5">
            <Button id="arrow-wrapper-right">Get a Quote</Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpecializeBilling;
